import classnames from 'classnames';
import { arrayOf, bool, node, oneOfType, string } from 'prop-types';
import React from 'react';
import { Col, Nav, Navbar, NavItem } from 'reactstrap';

function TitleHeader({ size, title }) {
  switch (size) {
    case 'sm':
      return <h4>{title}</h4>;
    case 'xs':
      return <h5>{title}</h5>;
    case 'tn':
      return <b>{title}</b>;
    case 'reg':
      return <span>{title}</span>;
    default:
      return <h3>{title}</h3>;
  }
}

TitleHeader.propTypes = {
  title: node.isRequired,
  size: string,
};

TitleHeader.defaultProps = {
  size: 'big',
};

function Titled({
  title,
  actions,
  children,
  size,
  sticky,
  className,
  noPadding,
  subHeader,
}) {
  return (
    <>
      <Navbar
        className={classnames(
          'p-0 bg-white',
          !noPadding && 'pb-3',
          sticky &&
            'sticky-top border-bottom c-secondary-sticky-navbar pt-3 mt-n3',
          className,
        )}
        expand
        light
      >
        <Col>
          <TitleHeader size={size} title={title} />
          <div className="sub-header">
            {Array.isArray(subHeader)
              ? subHeader.map(item => <div key={item}>{item}</div>)
              : subHeader}
          </div>
        </Col>

        <Nav className="ml-auto" navbar>
          {React.Children.map(actions, action => (
            <NavItem>{action}</NavItem>
          ))}
        </Nav>
      </Navbar>
      {children}
    </>
  );
}

Titled.propTypes = {
  title: node.isRequired,
  children: node,
  actions: node,
  size: string,
  sticky: bool,
  noPadding: bool,
  className: string,
  subHeader: oneOfType([string, node, arrayOf(node)]),
};

Titled.defaultProps = {
  actions: null,
  size: undefined,
  sticky: false,
  children: undefined,
  noPadding: false,
  className: '',
  subHeader: null,
};

export default Titled;
